import React, {useEffect, useState} from 'react'
import { Styling } from './styled.js'
import TextBlock from './TextBlock'
import ImageText from './ImageText'
import ImageImage from './ImageImage'
import ImageSlider from './ImageSlider'



export default function FlexibleContent({content}) {
    
   const [theGallery, setTheGallery] = useState()

   const getImages = () => {

       const gallery = []
           
       content.forEach((flex, index) => {
           
           if(flex.fieldGroupName.includes('Flexiblecontentmodules_FlexibleContent_ImageText')){
               gallery.push({image:flex.image})  
           } 
           if(flex.fieldGroupName.includes('Flexiblecontentmodules_FlexibleContent_ImageImage')){
               gallery.push({image:flex.image1})
           }
           if(flex.fieldGroupName.includes('Flexiblecontentmodules_FlexibleContent_ImageImage')){
            gallery.push({image:flex.image2})
           }
           if(flex.fieldGroupName.includes('Flexiblecontentmodules_FlexibleContent_ImageSlider')){
               flex.images.map(image => gallery.push({image:image.image}))
           }
       
       })
       
       console.log(gallery)

       
       
       setTheGallery(gallery)
       
      
   }


    useEffect(() => {
        getImages()
        
        return () => {
            
        }
    }, []);

    


    return (
        <Styling>
            {
                content.map((flex, index) => {
                    return (
                        flex.fieldGroupName.includes('Flexiblecontentmodules_FlexibleContent_TextBlock') 
                        ? <TextBlock key={'flex_'+index} text={flex.textGroup.text} width={flex.textGroup.width}/>
                        : flex.fieldGroupName.includes('Flexiblecontentmodules_FlexibleContent_ImageText') 
                        ? <ImageText key={'flex_'+index} alignment={flex.alignment} text={flex.text} image={flex.image} gallery={theGallery} />
                        : flex.fieldGroupName.includes('Flexiblecontentmodules_FlexibleContent_ImageImage') 
                        ? <ImageImage key={'flex_'+index} image1={flex.image1} image2={flex.image2} gallery={theGallery}/>
                        : flex.fieldGroupName.includes('Flexiblecontentmodules_FlexibleContent_ImageSlider') 
                        ? <ImageSlider key={'flex_'+index} images={flex.images} gallery={theGallery}/>
                        : ""
                    )

                })
            }
            
        </Styling>
    )
}
